<template>
  <v-app>
    <v-main style="background-color: #E4E4E4">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style lang="scss"></style>
